import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const zones = ["Paris", "Île-de-France", "France entière", "Europe"];

export const Zone = () => (
  <section id="zone" data-testid="zone-section" className="grain relative bg-[#f9f8f6] px-6 py-28 text-[#0a0a0a] lg:px-10 lg:py-40">
    <div className="mx-auto max-w-7xl">
      <div className="grid items-center gap-16 lg:grid-cols-2">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="mb-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-gold"
          >
            Zone d'intervention
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-display text-4xl leading-tight tracking-tight text-[#0a0a0a] sm:text-5xl lg:text-6xl"
          >
            Basés en Île-de-France, <br />
            <em className="italic text-[#aa8c2c]">présents partout en Europe.</em>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.2 }}
            className="mt-8 max-w-md text-sm leading-relaxed text-[#0a0a0a]/55"
          >
            Nos équipes se déplacent dans toute la France et partout en Europe pour vos
            mariages, vins d'honneur, conférences et réceptions. Les frais de déplacement
            sont à la charge du client.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="mt-10 flex flex-wrap gap-3"
          >
            {zones.map((z) => (
              <span
                key={z}
                data-testid={`zone-chip-${z.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="flex items-center gap-2 rounded-full border border-[#0a0a0a]/15 px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-[#0a0a0a]/70"
              >
                <MapPin className="h-3.5 w-3.5 text-gold" />
                {z}
              </span>
            ))}
          </motion.div>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <motion.figure
            data-testid="zone-photo-1"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="group overflow-hidden rounded-3xl border border-[#0a0a0a]/10"
          >
            <img
              src="/images/salle-moderne1.png"
              alt="Salle de réception de palace parisien doré"
              className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </motion.figure>
          <motion.figure
            data-testid="zone-photo-2"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="group mt-12 overflow-hidden rounded-3xl border border-white/10"
          >
            <img
              src="/images/salle-moderne2.png"
              alt="Hall somptueux d'un palace parisien avec escalier d'honneur"
              className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </motion.figure>
        </div>
      </div>
    </div>
  </section>
);
